import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from '../services/muvika';
import TR from './../Trans';
import messageStore from './message';

const initialState = {
  trendingTracks: null,
  publicPlaylists: null
};

const homeStore = create((set, get) => ({
  ...initialState,
  reset: () => { 
    set(initialState);
  },
  getTrendingTracks: (sessionToken, pageSize) => {
MuvikaService.getTop(sessionToken, pageSize, 1)
    .then(function (res) {
      if (res.data.error) {
        messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
      } else {
        set({ trendingTracks: res.data.data.items});
      }
    })
    .catch(function(){});
  },
  getPublicPlaylists: (sessionToken) => {
MuvikaService.getPublicPlaylists(sessionToken)
    .then(function (res) {
      if (res.data.error) {
        messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
      } else {
        set({ publicPlaylists: res.data.data.items});
      }
    })
    .catch(function(){});
  }
}));

export default homeStore;